import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { tokenText } from './tokenText';

// Same local canvas and PNG clipboard/download approach as My QR Code.
export default function EventTokenSharing({ url, label, infoSource }) {
  const canvas = useRef(null);
  const [notice, setNotice] = useState('');
  const t = tokenText(infoSource);
  const copy = async image => {
    try {
      if (image) {
        const blob = await new Promise(resolve => canvas.current.toBlob(resolve, 'image/png'));
        if (!blob || !navigator.clipboard?.write || typeof ClipboardItem === 'undefined') throw new Error();
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
      } else await navigator.clipboard.writeText(url);
      setNotice(t('copied'));
    } catch { setNotice(t('clipboardUnavailable')); }
  };
  return <section className="qr-share-panel event-sharing">
    <h4>{label}</h4>
    <div className="qr-share-row">
      <div className="qr-canvas-box"><QRCodeCanvas ref={canvas} value={url} size={144} level="H" marginSize={4} /></div>
      <div><a className="qr-url-bar" href={url}>{url}</a>
        <div className="qr-share-btns">
          <button type="button" className="qr-act-btn" onClick={() => copy(false)}>{t('copyLink')}</button>
          <button type="button" className="qr-act-btn" onClick={() => copy(true)}>{t('copyQr')}</button>
          <button type="button" className="qr-act-btn" onClick={() => {
            const link = document.createElement('a'); link.download = `Elakay-${label.replace(/[^a-z0-9]/gi, '-')}.png`;
            link.href = canvas.current.toDataURL('image/png'); link.click();
          }}>{t('downloadQr')}</button>
        </div>
      </div>
    </div>
    {notice && <p role="status">{notice}</p>}
  </section>;
}
